module.exports = __webpack_public_path__ + "86f50caeabcff8f63977e88f67b0de56.pdf";